import type { DBRecord } from '../services/PreferencesDB.ts';
import { CHARACTER_DEFAULT } from '../services/Directus.ts';

export class Profile implements DBRecord {
  id: string = '0';
  name: string = '';
  createdAt: number = Date.now();
  avatar: string = CHARACTER_DEFAULT;
  lastModified: number = Date.now();
  deletedKeys: { [key: string]: number } = {};
  sharedWith: string[] = [];

  toPlain(): object {
    return {
      id: this.id,
      name: this.name,
      createdAt: this.createdAt,
      avatar: this.avatar,
      lastModified: this.lastModified,
      deletedKeys: this.deletedKeys,
      sharedWith: this.sharedWith,
    };
  }
}
